<template>
  <d-message v-show="errors.length > 0" type="error" class="w-full mb-3" data-form-errors>
    <span v-if="errors.length == 1" class="text-danger text-error">{{ errors[0] }}</span>
    <ul v-else>
      <li v-for="error in errors" :key="error" class="text-danger text-error">
        {{ error }}
      </li>
    </ul>
  </d-message>
</template>

<script setup>
import { ref, inject, computed } from 'vue';
import { formatErrorMessages } from '../plugins/vee-validate-names';

// Local errors state
const rawErrors = ref([]);

// Try to inject form context from a parent component
const formContext = inject('form', null);

// Format the raw errors for display
const errors = computed(() => {
  return formatErrorMessages(rawErrors.value);
});

/**
 * Set errors to be displayed
 * 
 * @param {Array|Object|String} errorMessages - Errors to display
 */
const setErrors = (errorMessages) => {
  if (Array.isArray(errorMessages)) {
    rawErrors.value = errorMessages;
  } else if (typeof errorMessages === 'string') {
    rawErrors.value = [errorMessages];
  } else if (typeof errorMessages === 'object' && errorMessages !== null) {
    rawErrors.value = Object.values(errorMessages)
      .flat()
      .filter(Boolean);
  } else {
    rawErrors.value = [];
  }
};

/**
 * Clear all errors
 */
const clearErrors = () => {
  rawErrors.value = [];
};

/**
 * Add a new error
 * 
 * @param {String} error - Error message to add
 */
const addError = (error) => {
  if (error && !rawErrors.value.includes(error)) {
    rawErrors.value.push(error);
  }
};

/**
 * Remove a specific error
 * 
 * @param {String} error - Error message to remove
 */
const removeError = (error) => {
  const index = rawErrors.value.indexOf(error);
  if (index !== -1) {
    rawErrors.value.splice(index, 1);
  }
};

// Watch for form context errors if available
if (formContext && formContext.errors) {
  // This functionality can be added if needed with watch()
}

// Expose methods for external components to use
defineExpose({
  setErrors,
  clearErrors,
  addError,
  removeError
});
</script>
